<h2 class="default-dialog-header font-weight-normal" mat-dialog-title>
	<span fxFlex>{{ data.title }}</span>
	<span fxFlex fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog()" class="primary-light-color cursor-pointer">close</mat-icon>
	</span>
</h2>
<mat-divider></mat-divider>

<form (keydown.enter)="$event.preventDefault()" [formGroup]="maxBuyDetails">
	<mat-dialog-content class="default-dialog-content">
		<div class="p-8 m-t-1" fxLayout="row" fxLayoutAlign="center center">
			<div class="primary-text" fxFlex="30">Project Name</div>
			:&nbsp;&nbsp;
			<div fxFlex="70">{{ projectName }}</div>
		</div>
		<div class="p-8 m-t-1" fxLayout="row" fxLayoutAlign="center center">
			<div class="primary-text" fxFlex="30">Lane</div>
			:&nbsp;&nbsp;
			<div fxFlex="70">{{ lane }}</div>
		</div>
		<div class="p-8 m-t-1" fxLayout="row" fxLayoutAlign="center center">
			<div class="primary-text" fxFlex="30">Current Max Buy</div>
			:&nbsp;&nbsp;
			<div fxFlex="70">{{ currentMaxBuy }}</div>
		</div>
		<div class="p-8" fxLayout="row" fxLayoutAlign="center center">
			<div class="primary-text" fxFlex="30">Reduce To</div>
			:&nbsp;&nbsp;
			<mat-form-field floatLabel="never" fxFlex="40">
				<mat-icon class="primary-light-color vertical-align-bottom" matPrefix
					>attach_money</mat-icon
				>
				<input
					autocomplete="off"
					formControlName="maxBuy"
					mask="separator"
					thousandSeparator=","
					prefix="$"
					matInput
				/>
			</mat-form-field>
			<div fxFlex></div>
		</div>
	</mat-dialog-content>
	<mat-divider></mat-divider>

	<mat-dialog-actions class="default-dialog-action">
		<div fxFlex="100" fxLayoutAlign="end center" fxLayoutGap="1rem">
			<button
				(click)="submitMaxBuy()"
				[disabled]="maxBuyDetails.invalid"
				color="primary"
				mat-raised-button
			>
				Update
			</button>
		</div>
	</mat-dialog-actions>
</form>
